import { render, staticRenderFns } from "./item-new.vue?vue&type=template&id=99174c9c"
import script from "./item-new.vue?vue&type=script&lang=js"
export * from "./item-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports